var rich_content_viewer_default = {
  "fontElementMap": "c0wVm",
  "wrapper": "MIvWD",
  "pluginContainerMobile": "fS9vj",
  "viewer": "CqvLv",
  "android": "bE4-r",
  "rootedTraversedContent": "_6EiaF",
  "atomic": "akwoR",
  "toolbar": "dy3y9",
  "block": "YOmdv"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
